import { useDeployedVersion } from "../hooks/use-deployed-version";

const BUNDLED_COMMIT = import.meta.env.VITE_BUILD_COMMIT ?? "local";

function refreshWithCacheBust(): void {
  const url = new URL(window.location.href);
  url.searchParams.set("_v", String(Date.now()));
  window.location.href = url.toString();
}

export function NewVersionBanner() {
  const deployedCommit = useDeployedVersion();

  if (BUNDLED_COMMIT === "local") return null;
  if (!deployedCommit || deployedCommit === "local") return null;
  if (deployedCommit === BUNDLED_COMMIT) return null;

  return (
    <div
      role="status"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1000,
        background: "#1e40af",
        color: "white",
        padding: "10px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
        fontSize: 14,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <span>
        A new version of Otto is available.
        <span style={{ opacity: 0.75, marginLeft: 8, fontSize: 12 }}>
          ({BUNDLED_COMMIT.slice(0, 7)} → {deployedCommit.slice(0, 7)})
        </span>
      </span>
      <button
        type="button"
        onClick={refreshWithCacheBust}
        style={{
          background: "white",
          color: "#1e40af",
          border: "none",
          padding: "6px 14px",
          borderRadius: 4,
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Refresh now
      </button>
    </div>
  );
}
